const colorSchemes = {
  mainG: '#00a61c',
  subG: '#2ac840',
  lightG: '#eef3e4',

  G1: 'grey',
  G2: 'lightGrey',
  G3: '#e5e5e5',
  G4: '#8a8a8a',
  G5: '#d9d9d9',
  G6: '#00000003',
  G7: '#c6c6c6',
  BK: '#000',
  W1: '#fff',
  W2: '#f7f7f7',
  W3: '#f2f2f2',
  W4: '#f3f3f3',
  WS: 'whitesmoke',

  // 차트(Doughnut)
  D1: '#6bd1f1',
  D2: '#0088ff',
  D3: '#a8a8a8',
  D4: '#9b429d',
  D5: '#ff8e1d',
}

export default colorSchemes
